import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Status from "../../../../Componets/Status";
import ActionButton from "../../../../Componets/Buttons/action";
import Table from "../../../../Componets/Table";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Employees/Employees/tables";
import headers from "../../../../Data/Tables/Employees/Employees/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { get_all_employees } from "../../../../Controllers/Employees/Employees";

const EmployeesTable = () => {
  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();
  const [header, setHeader] = useState(headers);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const paginationdata = (data) => {
    let headerdata = {};
    headers?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      role: headerdata?.role,
      status: headerdata?.status,
    });
  };

  const formdata = (data) => {
    fetchData(data);
  };

  const actiondata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const params = {
        search: tabledata?.search,
        role: tabledata?.role,
        status: tabledata?.status,
        sort: tabledata?.sort,
      };

      const employees = await get_all_employees(params);

      if (employees?.status) {
        let data = [];

        employees?.data?.data?.map((value, index) => {
          data?.push({
            Name: value?.name,
            Role: value?.role?.name,
            Email: value?.email,
            Phone: value?.phone,
            Status: <Status status={value?.status} />,
            Action: (
              <ActionButton
                edit={`/app/employees/edit/${value?._id}`}
                id={value?._id}
                api="delete-employee"
                actiondata={actiondata}
              />
            ),
          });
        });

        setPagination({
          currentPage: employees?.data?.currentPage,
          totalCount: employees?.data?.totalCount,
          totalPages: employees?.data?.totalPages,
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(employees?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
        />
      </Loadercomponent>
    </Header>
  );
};

export default EmployeesTable;
